export const products = [
  {
    id: 'pwr-01',
    category: 'Power',
    name: 'Kairo Core 20k',
    subtitle: 'High-Capacity Power Bank',
    price: 89.99,
    image: 'https://images.unsplash.com/photo-1609091839697-ebc48710ba9b?auto=format&fit=crop&q=80&w=800',
    specs: { capacity: '20,000mAh', output: '65W Max', weight: '380g' },
    compatibility: ['MacBook Pro', 'iPad Air', 'iPhone 15', '65W PD'],
    stock: 'IN STOCK',
    status: 'ONLINE'
  },
  {
    id: 'pwr-02',
    category: 'Power',
    name: 'AeroCharge Mini',
    subtitle: 'Ultra-Compact Cell',
    price: 45.00,
    image: 'https://images.unsplash.com/photo-1619134011440-2720d200388d?auto=format&fit=crop&q=80&w=800',
    specs: { capacity: '10,000mAh', output: '20W Max', weight: '195g' },
    compatibility: ['iPhone', 'Android', 'AirPods'],
    stock: 'LOW STOCK',
    status: 'WARNING'
  },
  {
    id: 'cbl-01',
    category: 'Cable',
    name: 'TitanWeave 100W',
    subtitle: 'Kevlar Reinforced USB-C',
    price: 24.50,
    image: 'https://images.unsplash.com/photo-1589939705384-5185137a7f0f?auto=format&fit=crop&q=80&w=800',
    specs: { length: '2m / 6.5ft', material: 'Kevlar Braid', speed: '40Gbps' },
    compatibility: ['USB-C', 'Thunderbolt 4', 'Universal'],
    stock: 'IN STOCK',
    status: 'ONLINE'
  },
  {
    id: 'cbl-02',
    category: 'Cable',
    name: 'MagConnect Pro',
    subtitle: 'Magnetic Multi-Head',
    price: 32.00,
    image: 'https://images.unsplash.com/photo-1625766127179-88004f64790a?auto=format&fit=crop&q=80&w=800',
    specs: { length: '1.5m', heads: '3-in-1', speed: '480Mbps' },
    compatibility: ['iOS', 'USB-C', 'Micro-USB'],
    stock: 'IN STOCK',
    status: 'ONLINE'
  },
  {
    id: 'adp-01',
    category: 'Adapter',
    name: 'GlobalLink GaN 65W',
    subtitle: 'Universal Travel Adapter',
    price: 55.00,
    image: 'https://images.unsplash.com/photo-1585338107529-13afc5f02586?auto=format&fit=crop&q=80&w=800',
    specs: { tech: 'GaN II', regions: '200+ Countries', output: '65W' },
    compatibility: ['Global', 'MacBook', 'Type A/C/G/I'],
    stock: 'IN STOCK',
    status: 'ONLINE'
  },
  {
    id: 'adp-02',
    category: 'Adapter',
    name: 'EuroPlug Nano',
    subtitle: 'Slim EU Converter',
    price: 15.00,
    image: 'https://images.unsplash.com/photo-1610492419974-9548f07be864?auto=format&fit=crop&q=80&w=800',
    specs: { tech: 'Standard', regions: 'US to EU', weight: '45g' },
    compatibility: ['EU Region', 'Type C/E/F'],
    stock: 'OUT OF STOCK',
    status: 'OFFLINE'
  }
];